
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface CategoryKeywordManagerProps {
  keywords: string[];
  keywordsInput: string;
  setKeywordsInput: (value: string) => void;
  handleAddKeyword: () => void;
  handleRemoveKeyword: (keyword: string) => void;
}

const CategoryKeywordManager = ({
  keywords,
  keywordsInput,
  setKeywordsInput,
  handleAddKeyword,
  handleRemoveKeyword
}: CategoryKeywordManagerProps) => {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Keywords/Tags</label>
      <div className="flex gap-2">
        <Input
          value={keywordsInput}
          onChange={(e) => setKeywordsInput(e.target.value)}
          placeholder="Enter keywords, separated by commas"
        />
        <Button type="button" onClick={handleAddKeyword} size="sm">
          Add
        </Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {keywords.map((keyword, index) => (
          <Badge key={index} variant="secondary" className="px-2 py-1">
            {keyword}
            <button
              type="button"
              className="ml-1 text-muted-foreground hover:text-foreground"
              onClick={() => handleRemoveKeyword(keyword)}
            >
              ×
            </button>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default CategoryKeywordManager;
